/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateUnplannedOtDto } from '../../models/create-unplanned-ot-dto';
import { CreateUnplannedOtResponse } from '../../models/create-unplanned-ot-response';

export interface CreateUnplannedOt$Params {
  body: CreateUnplannedOtDto;
}

export function createUnplannedOt(
  http: HttpClient,
  rootUrl: string,
  params: CreateUnplannedOt$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<CreateUnplannedOtResponse>> {
  const rb = new RequestBuilder(rootUrl, createUnplannedOt.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'blob', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateUnplannedOtResponse>;
    })
  );
}

createUnplannedOt.PATH = '/v2/ots/create_unplanned_ot';
